/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_Ahead_AddInputs */

const en_editor_prep_ahead_add = /** @type {(inputs: Editor_Prep_Ahead_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task`)
};

const de_editor_prep_ahead_add = /** @type {(inputs: Editor_Prep_Ahead_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabe`)
};

/**
* | output |
* | --- |
* | "Task" |
*
* @param {Editor_Prep_Ahead_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_ahead_add = /** @type {((inputs?: Editor_Prep_Ahead_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_Ahead_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_ahead_add(inputs)
	return en_editor_prep_ahead_add(inputs)
});